<template>
		<div class="loginIm">
			<ul class="inputList ">
				<!-- <li style="padding-left: 0;">
					<h1>登录-客汇宝畅聊</h1>
					<i class="el-icon-close" @click="closeLg()"></i>
				</li> -->
				<li>
					<label>手机</label>
					<el-input size="medium" type="tel" v-model="phone" placeholder="输入手机号" @input="specifiName($event)" ></el-input>
				</li>
				<li>
					<label>图形验证码</label>
					<el-input size="medium" type="tel" v-model="myImgYZM" placeholder="输入验证码"></el-input>
					<span  class="imgyzm">
						<img :src="imgYZMData"  @click="changeYZM" />
					</span>				
				</li>
				<li>
					<label>验证</label>
					<el-input size="medium" type="tel" v-model="myYZM" placeholder="输入验证码"></el-input>
					<span @click="timing" v-if="getYZM">获取验证码</span>
					<span v-if="!getYZM">{{numb}}s</span>					
				</li>
				<li v-if="register_codeShow!='1'">
					<label>邀请码</label>
					<el-input size="medium"  v-model="register_code" placeholder="输入邀请码"></el-input>				
				</li>
			</ul>
			<div class="btnMargin">
				<el-button type="primary" size="medium" @click="Verification">登录</el-button>
			</div>
		</div>
</template>

<script>
import {getMimcInfo} from '@/xiaomi/mimc.js';		
import qs from "qs"	
export default {
	data(){
		return{
			numb:60,
  		getYZM:true,
  		phone:'',
  		myYZM:'',
  		imgYZM:'',
  		keyYZM:'',
  		myImgYZM:'',
  		register_code:'',
  		register_codeShow:1,
		}
	},
  computed: {
    // 计算属性的 getter
    imgYZMData: function () {
      return this.imgYZM
    }
  },	
  methods:{
	specifiName(val) {
		//验证手机号
        var myreg=/^[1][0,1,2,3,4,5,7,8,9][0-9]{9}$/;
        if(myreg.test(this.phone)){
        	this.checkPhone()
        } 
	}, 
  	checkPhone(){		
					let params = qs.stringify({
										account:this.phone,
					  })
						this.$axios.post('/goods/user/v1/checkAccount',params)
						.then(userData=>{
							if(userData.data.resultCode=='0000'){
								this.register_codeShow=userData.data.resultInfo.sign
								
							}else{
								this.$message.error(userData.data.resultMsg);
							}	
						}).catch(error=>{
							console.log(error)
						})  		
  	},	
  	changeYZM(){
  		this.keyYZM=this.randomString(8)
			this.imgYZM='http://'+window.location.host+'/goods/code/imgCode/'+this.keyYZM
  	},
  	randomString(len) {
	    　　len = len || 32;
	    　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
	    　　var maxPos = $chars.length;
	    　　var pwd = '';
	    　　for (var i = 0; i < len; i++) {
	    　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
	    　　}
	     　　return pwd;
    }, 
  	timing(){
  		 
		//验证手机号
        var myreg=/^[1][0,1,2,3,4,5,7,8,9][0-9]{9}$/;
        if(!myreg.test(this.phone)){
        	 this.$message.error('手机号码错误');
        	return false
        } 
        if(this.myImgYZM==''){
        	this.$message.error("图形验证有误");
        	return false
        }  
  		this.getYZM=false 
	  	var	clearTime=setInterval(time=>{
	 				this.numb=this.numb-1;
	 				if(this.numb<=0){
	 					clearInterval(clearTime);
	 					this.numb=60;
	 					this.getYZM=true;
	 				}
	 				
	  		},1000);
	  	this.setYZM();
  	}, 	
  	setYZM(){  		
			let params = qs.stringify({
				goods_user_name:this.phone,
				send_type:"login_content",
				key:this.keyYZM,
				imgCode:this.myImgYZM
			})
			this.$axios.post('/goods/code/v2/send_check_code',params)
			.then(userData=>{
				if(userData.data.resultCode=='0000'){
						 this.$message('已发送验证码');
				}else{
					 this.$message.error(userData.data.resultMsg);
				}
			}).catch(error=>{
				console.log(error)
			})  		
  	},
  	Verification(){
			//验证手机号
            var myreg=/^[1][0,1,2,3,4,5,7,8,9][0-9]{9}$/;
            if(!myreg.test(this.phone)){
            	 this.$message.error('手机号码错误');
            	return false
            }
            if(this.myYZM==""){
            	this.$message.error('请输入验证码');
            	return false
            }
            if(this.register_codeShow!='1'&&this.register_code==''){
            	this.$message.error('请输入邀请码');
            	return false
            }
			this.next()
  	},
	setcookie (name, value){ 
	    //设置名称为name,值为value的Cookie
	    var expdate = new Date();   //初始化时间
	    expdate.setTime(expdate.getTime() + 24*7*60 * 60 * 1000);   //时间单位毫秒 过期时间30分钟
	    document.cookie = name+"="+escape(value)+";expires="+expdate.toGMTString()+";path=/";
	},
	getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length>0){
	  var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 
	   var c_end=document.cookie.indexOf(";",c_start)
	    if (c_end==-1) c_end=document.cookie.length
	    return unescape(unescape(document.cookie.substring(c_start,c_end)))
	    } 
	  }
	return ""
	},	
  	next(){		
				var uid='';
				var typ='';
				if(this.$route.query.uid!=undefined){
					uid=this.$route.query.uid
					typ='weibo'
				}
				if(this.$route.query.sp){}
					let params = qs.stringify({
										account:this.phone,
										type:'smscode',
										sign:this.myYZM,
										login_uid:uid,
										login_type:typ,
										register_code:this.register_code
					  })
						this.$axios.post('/goods/user/v2/user_register_login',params)
						.then(userData=>{
							if(userData.data.resultCode=='0000'){
								this.$store.commit('loginTrueFc',true);
								localStorage.setItem("loginTrue", "yes");
								this.setcookie('mytokenIm',userData.data.resultInfo.goodsUserToken)
								this.setcookie('phoneIm',this.phone)
								this.userInfo()
								this.$router.push({name:'Chatwindow'})
							}else{
								this.$message.error(userData.data.resultMsg);
							}	
						}).catch(error=>{
							console.log(error)
						})  		
  	},
  	userInfo(){
  		this.$axios.defaults.headers.common['token'] =this.getCookie('mytokenIm')
			this.$axios.post('/goods/mimc/v1/queryUserInfo')
			.then(userData=>{
				if(userData.data.resultCode=='0000'){
							var that=this
							this.setcookie('userInfo',JSON.stringify(userData.data.resultInfo))
						  	getMimcInfo(this.phone,function(status){
						  		if(status){
						  			//that.$message("登录成功");
						  			that.$parent.$parent.$parent.$parent.logingo();
						  		}else{
						  			that.$message.error('登录失败');
						  		}
						  	})									
					
				}else{
					this.$message.error(userData.data.resultMsg);
				}	
			}).catch(error=>{
				console.log(error)
			})  		
  	},  
  	// closeLg(){
  	// 	this.$parent.loginShowClose();
  	// }
  },
  created:function(){
	  	this.keyYZM=this.randomString(8)
		this.imgYZM='http://'+window.location.host+'/goods/code/imgCode/'+this.keyYZM
  },
}
</script>
<style scoped>
.yz{
	position: relative;
}	
.yz span{
	position: absolute;
	right: 0;
}
.inputList{
	background: #FFFFFF;
	margin-top: 5px;
	/* padding: 0px 15px; */
}
.inputList li{
	position: relative;
	margin: 10px;
	padding-left: 100px;
}
.inputList li h1{
	line-height: 40px;
	font-weight: normal;
	font-size: 20px;
}
.inputList li i{
	position: absolute;
	right: 0;
	top: 5px;
	font-size: 20px;
}
.inputList label{
	display: block;
	font-size: 16px;
	padding-right: 15px;
	float: left;
	width: 100px;
	text-align: left;
	position: absolute;
	left: 0;
	line-height: 31px;
}
.inputList input{
	float: left;
	font-size: 20px;
}
.inputList span{
	position: absolute;
	top: 0;
	right: 10px;
	line-height: 31px;
}
.imgyzm{
	height: 90%;
	line-break: normal !important;
	top: 5% !important;
}
.imgyzm img{
	height: 100%;

}
.inputList .imgYZM{
	position: absolute;
	right: 0;
	cursor: pointer;
}
.btnMargin{
	padding: 15px;
	padding-top: 20px;
}
.btnMargin button{
	font-weight: bold;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/im/loginyzm.vue